import { trigger, state, animate, stagger, style, group, query, transition, keyframes  } from '@angular/animations';
// import { AnimateService } from '../animate.service';
// const animateService = new AnimateService;
// const returned = animateService.returned;

export const mediaQuerys = {
    '1680px': window.matchMedia("screen and (max-width: 1680px)"),
    '1400px': window.matchMedia("screen and (max-width: 1400px)"),
    '1300px': window.matchMedia("screen and (max-width: 1300px)"),
    '1050px': window.matchMedia("screen and (max-width: 1050px)"),
    '1000px': window.matchMedia("screen and (max-width: 1000px)"),
    '800px': window.matchMedia("screen and (max-width: 800px)"),
    '500px': window.matchMedia("screen and (max-width: 500px)")
};

export function returned(arrayAnimate, defaultState){
    let viewSelect = false;
    if(arrayAnimate){
        arrayAnimate.forEach(el => {
            if(el.view){
                viewSelect = el.state;
                return el.state;
            }
        });
        if(viewSelect){
            return viewSelect;
        }
        return defaultState;
    }
}

//animate menu
export const menuAnimate = 
    returned([
        {
            //1680px
            'view' : mediaQuerys["1680px"].matches,
            'state' : trigger('menuAnimate', [
                state('hide', style({
                    opacity: 0,
                    'z-index': -1,
                    display: 'none'
                })),
                state('show', style({
                    opacity: 1,
                    'z-index': 101,
                    width: 'calc(100% - 160px)',
                    display: 'block'
                })),
                transition('hide => show', [
                    style({
                        opacity: 1,
                        'z-index': 1,
                        width: 'calc(100% - 160px)',
                        display: 'block'
                    }),
                    query('.bg', style({
                        width: '0px'
                    })),
                    query('.menu  ul  li  a  span', style({
                        top: '-120px'
                    })),
                    query('.menu .line', style({
                        right: '-120%'
                    })),
                    query('.left-menu .line', style({
                        top: '-120%'
                    })),
                    query('.left-menu .icon-list li a, .left-menu .icon-list li button', style({
                        top: '-50px'
                    }), { optional: true}),
                    query('.left-menu .by span', style({
                        top: '-50px'
                    })),
                    query('.left-menu .close-menu', style({
                        opacity: 0
                    })),
                    //animate
                    query('.bg', animate('0.6s ease-out', style({
                        width: '100%'
                    }))),
                    group([
                        query('.menu  ul  li  a  span', stagger(100, [ 
                                animate('0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55)', style({
                                    top: '0px'
                                }))
                            ])
                        ),
                        query('.menu .line', animate('0.5s ease-out',  style({
                            right: '52%'
                        }))),
                        query('.left-menu .line', animate('0.51s ease-out',  style({
                            top: '0'
                        }))),
                        query('.left-menu .icon-list li a, .left-menu .icon-list li button', animate('0.5s 0.5s ease-out', style({
                            top: '0px'
                        })), { optional: true}),
                        query('.left-menu .by span', animate('0.5s 0.5s ease-out', style({
                            top: '0px'
                        }))),
                    ]),
                    query('.left-menu .close-menu', animate('0.5s ease-out', style({
                        opacity: 1
                    })))
                ]),
                transition('show => hide', [
                    group([
                        query('.left-menu .close-menu', animate('0.2s ease-out', style({
                            opacity: 0
                        }))),
                        query('.menu  ul  li  a  span', animate('0.9s cubic-bezier(0.68, -0.55, 0.265, 1.55)', style({
                            top: '-100px'
                        }))),
                        query('.menu > ul > li ul li', animate('0.9s cubic-bezier(0.68, -0.55, 0.265, 1.55)', style({
                            transform: 'translateX(-35px)',
                            opacity: 0
                        }))),               
                        query('.left-menu .icon-list li a, .left-menu .icon-list li button', animate('0.7s ease-out', style({
                            top: '-50px'
                        })), { optional: true}),
                        query('.left-menu .by span', animate('0.7s ease-out', style({
                            top: '-50px'
                        }))),
        
                        query('.menu .line', animate('0.3s 0.5s ease-out',  style({
                            right: '-120%'
                        }))),
                        query('.left-menu .line', animate('0.3s 0.5s ease-out',  style({
                            top: '-120%'
                        }))),
                        query('.bg', animate('0.8s 0.2s ease-out', style({
                            width: 0
                        }))),
                        query('.bg', animate('1s ease-out', keyframes([
                            style({ width: '100%', offset: 0 }),
                            style({ width: '100%', offset: 0.8 }),
                            style({ width: '0%', offset: 1 })
                        ])))
                    ]),
                ])
            ])
        },
        {
            //1400px
            'view' : mediaQuerys["1400px"].matches,
            'state' : trigger('menuAnimate', [
                state('hide', style({
                    opacity: 0,
                    'z-index': -1,
                    display: 'none'
                })),
                state('show', style({
                    opacity: 1,
                    'z-index': 101,
                    width: 'calc(100% - 160px)',
                    display: 'block'
                })),
                transition('hide => show', [
                    style({
                        opacity: 1,
                        'z-index': 1,
                        width: 'calc(100% - 160px)',
                        display: 'block'
                    }),
                    query('.bg', style({
                        width: '0px'
                    })),
                    query('.menu  ul  li  a  span', style({
                        top: '-120px'
                    })),
                    query('.menu .line', style({
                        right: '-120%'
                    })),
                    query('.left-menu .line', style({
                        top: '-120%'
                    })),
                    query('.left-menu .icon-list li a, .left-menu .icon-list li button', style({
                        top: '-50px'
                    }), { optional: true}),
                    query('.left-menu .by span', style({
                        top: '-50px'
                    })),
                    query('.left-menu .close-menu', style({
                        opacity: 0
                    })),
                    //animate
                    query('.bg', animate('0.6s ease-out', style({
                        width: '100%'
                    }))),        
                    group([
                        query('.menu  ul  li  a  span', stagger(100, [ 
                                animate('0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55)', style({
                                    top: '0px'
                                }))
                            ])
                        ),
                        query('.menu .line', animate('0.5s ease-out',  style({
                            right: '52%'
                        }))),
                        query('.left-menu .line', animate('0.51s ease-out',  style({
                            top: '0'
                        }))),
                        query('.left-menu .icon-list li a, .left-menu .icon-list li button', animate('0.5s 0.5s ease-out', style({
                            top: '0px'
                        })), { optional: true}),
                        query('.left-menu .by span', animate('0.5s 0.5s ease-out', style({
                            top: '0px'
                        }))),
                    ]),
                    query('.left-menu .close-menu', animate('0.5s ease-out', style({
                        opacity: 1
                    })))
                ]),
                transition('show => hide', [
                    group([
                        query('.left-menu .close-menu', animate('0.2s ease-out', style({
                            opacity: 0
                        }))),
                        query('.menu  ul  li  a  span', animate('0.9s cubic-bezier(0.68, -0.55, 0.265, 1.55)', style({
                            top: '-100px'
                        }))),
                        query('.menu > ul > li ul li', animate('0.9s cubic-bezier(0.68, -0.55, 0.265, 1.55)', style({
                            transform: 'translateX(-35px)',
                            opacity: 0
                        }))),               
                        query('.left-menu .icon-list li a, .left-menu .icon-list li button', animate('0.7s ease-out', style({
                            top: '-50px'
                        })), { optional: true}),
                        query('.left-menu .by span', animate('0.7s ease-out', style({
                            top: '-50px'
                        }))),
        
                        query('.menu .line', animate('0.3s 0.5s ease-out',  style({
                            right: '-120%'
                        }))),
                        query('.left-menu .line', animate('0.3s 0.5s ease-out',  style({
                            top: '-120%'
                        }))),
                        query('.bg', animate('0.8s 0.2s ease-out', style({
                            width: 0
                        }))),
                        query('.bg', animate('1s ease-out', keyframes([
                            style({ width: '100%', offset: 0 }),
                            style({ width: '100%', offset: 0.8 }),
                            style({ width: '0%', offset: 1 })
                        ])))
                    ]),
                ])
            ])
        },
        {
            //1050px
            'view' : mediaQuerys["1050px"].matches,
            'state' : trigger('menuAnimate', [
                state('hide', style({
                    opacity: 0,
                    'z-index': -1,
                    display: 'none'
                })),
                state('show', style({
                    opacity: 1,
                    'z-index': 101,
                    width: '100%',
                    display: 'block'
                })),
                transition('hide => show', [
                    style({
                        opacity: 1,
                        'z-index': 1,
                        width: '100%',
                        display: 'block'
                    }),
                    query('.left-menu .icon-list li a, .left-menu .icon-list li button', style({
                        top: '-50px'
                    }), { optional: true}),
                    query('.bg', style({
                        width: '0px'
                    })),
                    query('.left-menu .close-menu', style({
                        opacity: 0
                    })),
                    query('.left-menu a span', style({
                        top: '-50px'
                    })),
                    query('.my-caret', style({
                        top: '-50px'
                    })),
                    query('.fullmenu .menu > ul > li ul li a', style({
                        top: '-50px'
                    })),  
                    query('.by', style({
                        opacity: '0'
                    })),   
                    query('.left-menu .line', style({
                        opacity: '0',
                        top: '-100%'
                    })),        
                    //animate
                    query('.bg', animate('0.8s ease-out', 
                        style({
                            width: '100%'
                        })
                    )),                    
                    group([
                        query('.my-caret', animate('0.5s ease-out', style({
                            top: '0px'
                        }))),
                        query('.left-menu a span', animate('0.5s ease-out', 
                            style({
                                top: '0px'
                            })
                        )),
                        query('.fullmenu .menu > ul > li ul li a', animate('0.5s ease-out', style({
                            top: '-50px'
                        }))),  
                        query('.left-menu .icon-list li a, .left-menu .icon-list li button', animate('0.5s ease-out', style({
                            top: '0px'
                        })), { optional: true}),
                        query('.left-menu .line', animate('0.5s ease-out', style({
                            opacity: 1,
                            top: 0
                        }))), 
                    ]),  
                    query('.by', animate('0.4s ease-out', style({
                        opacity: 1
                    }))),                   
                    query('.left-menu .close-menu', animate('1s ease-out', 
                        style({
                            opacity: 1
                        })
                    )),
                ]),
                transition('show => hide', [   
                    query('.left-menu .close-menu', animate('0.4s ease-out', 
                        style({
                            opacity: 0
                        })
                    )),                
                    group([
                        query('.left-menu .line', animate('0.5s ease-out', style({
                            opacity: '0',
                            top: '-100%'
                        }))), 
                        query('.my-caret', animate('0.3s ease-out', style({
                            top: '-50px'
                        }))),
                        query('.left-menu a span', animate('0.3s ease-out', 
                            style({
                                top: '-50px'
                            })
                        )),
                        query('.left-menu .icon-list li a, .left-menu .icon-list li button', animate('0.3s ease-out', style({
                            top: '-50px'
                        })), { optional: true}),
                        query('.by', animate('0.4s ease-out', style({
                            opacity: 0
                        }))), 
                        query('.fullmenu .menu > ul > li ul li a', animate('0.5s ease-out', style({
                            top: '-50px'
                        }))), 
                    ]),            
                    query('.bg', animate('0.4s ease-out', 
                        style({
                            width: '0%'
                        })
                    )), 
                ])
            ])
        },
        {
            //800px
            'view' : mediaQuerys["800px"].matches,
            'state' : trigger('menuAnimate', [
                state('hide', style({
                    opacity: 0,
                    'z-index': -1,
                    display: 'none'
                })),
                state('show', style({
                    opacity: 1,
                    'z-index': 101,
                    width: '100%',
                    display: 'block'
                })),
                transition('hide => show', [
                    style({
                        opacity: 1,
                        'z-index': 1,
                        width: '100%',
                        display: 'block'
                    }),
                    query('.left-menu .icon-list li a, .left-menu .icon-list li button', style({
                        top: '-50px'
                    }), { optional: true}),
                    query('.bg', style({
                        width: '0px'
                    })),
                    query('.left-menu .close-menu', style({
                        opacity: 0
                    })),
                    query('.left-menu a span', style({
                        top: '-50px'
                    })),
                    query('.my-caret', style({
                        top: '-50px'
                    })),
                    query('.by', style({
                        opacity: '0'
                    })),   
                    query('.left-menu .line', style({
                        opacity: '0',
                        top: '-100%'
                    })),        
                    //animate
                    query('.bg', animate('0.4s ease-out', 
                        style({
                            width: '100%'
                        })
                    )),                    
                    group([
                        query('.my-caret', animate('0.3s ease-out', style({
                            top: '0px'
                        }))),
                        query('.left-menu a span', animate('0.3s ease-out', 
                            style({
                                top: '0px'
                            })
                        )), 
                        query('.left-menu .icon-list li a, .left-menu .icon-list li button', animate('0.3s ease-out', style({
                            top: '0px'
                        })), { optional: true}),
                        query('.left-menu .line', animate('0.3s ease-out', style({
                            opacity: 1,
                            top: 0
                        }))), 
                    ]),  
                    query('.by', animate('0.3s ease-out', style({
                        opacity: 1
                    }))),                   
                    query('.left-menu .close-menu', animate('0.5s ease-out', 
                        style({
                            opacity: 1
                        })
                    )),
                ]),
                transition('show => hide', [   
                    query('.left-menu .close-menu', animate('0.4s ease-out', 
                        style({
                            opacity: 0
                        })
                    )),                
                    group([
                        query('.left-menu .line', animate('0.5s ease-out', style({
                            opacity: '0',
                            top: '-100%'
                        }))), 
                        query('.my-caret', animate('0.3s ease-out', style({
                            top: '-50px'
                        }))),
                        query('.left-menu a span', animate('0.3s ease-out', 
                            style({
                                top: '-50px'
                            })
                        )),
                        query('.left-menu .icon-list li a, .left-menu .icon-list li button', animate('0.3s ease-out', style({
                            top: '-50px'
                        })), { optional: true}),
                        query('.by', animate('0.4s ease-out', style({
                            opacity: 0
                        }))), 
                    ]),            
                    query('.bg', animate('0.4s ease-out', 
                        style({
                            width: '0%'
                        })
                    )), 
                ])
            ])
        }
    ], 
    trigger('menuAnimate', [
        state('hide', style({
            opacity: 0,
            'z-index': -1,
            display: 'none'
        })),
        state('show', style({
            opacity: 1,
            'z-index': 101,
            width: '87%',
            display: 'block'
        })),
        transition('hide => show', [
            style({
                opacity: 1,
                'z-index': 1,
                width: '87%',
                display: 'block'
            }),
            query('.bg', style({
                width: '0px'
            })),
            query('.menu  ul  li  a  span', style({
                top: '-120px'
            })),
            query('.menu .line', style({
                right: '-120%'
            })),
            query('.left-menu .line', style({
                top: '-120%'
            })),
            query('.left-menu .icon-list li a, .left-menu .icon-list li button', style({
                top: '-50px'
            }), { optional: true}),
            query('.left-menu .by span', style({
                top: '-50px'
            })),
            query('.left-menu .close-menu', style({
                opacity: 0
            })),
            //animate
            query('.bg', animate('0.6s ease-out', style({
                width: '100%'
            }))),
            group([
                query('.menu  ul  li  a  span', stagger(100, [ 
                        animate('0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55)', style({
                            top: '0px'
                        }))
                    ])
                ),
                query('.menu .line', animate('0.5s ease-out',  style({
                    right: '52%'
                }))),
                query('.left-menu .line', animate('0.51s ease-out',  style({
                    top: '0'
                }))),
                query('.left-menu .icon-list li a, .left-menu .icon-list li button', animate('0.5s 0.5s ease-out', style({
                    top: '0px'
                })), { optional: true}),
                query('.left-menu .by span', animate('0.5s 0.5s ease-out', style({
                    top: '0px'
                }))),
            ]),
            query('.left-menu .close-menu', animate('0.5s ease-out', style({
                opacity: 1
            })))
        ]),
        transition('show => hide', [
            group([
                query('.left-menu .close-menu', animate('0.2s ease-out', style({
                    opacity: 0
                }))),
                query('.menu  ul  li  a  span', animate('0.9s cubic-bezier(0.68, -0.55, 0.265, 1.55)', style({
                    top: '-100px'
                }))),
                query('.menu > ul > li ul li', animate('0.9s cubic-bezier(0.68, -0.55, 0.265, 1.55)', style({
                    transform: 'translateX(-35px)',
                    opacity: 0
                }))),               
                query('.left-menu .icon-list li a, .left-menu .icon-list li button', animate('0.7s ease-out', style({
                    top: '-50px'
                })), { optional: true}),
                query('.left-menu .by span', animate('0.7s ease-out', style({
                    top: '-50px'
                }))),

                query('.menu .line', animate('0.3s 0.5s ease-out',  style({
                    right: '-120%'
                }))),
                query('.left-menu .line', animate('0.3s 0.5s ease-out',  style({
                    top: '-120%'
                }))),
                query('.bg', animate('0.8s 0.2s ease-out', style({
                    width: 0
                }))),
                query('.bg', animate('1s ease-out', keyframes([
                    style({ width: '100%', offset: 0 }),
                    style({ width: '100%', offset: 0.8 }),
                    style({ width: '0%', offset: 1 })
                ])))
            ]),
        ])
    ]));

//contact animate mobile
export const contactMobileInfo = trigger('contactMobileInfo', [
        state('hide', style({
            display: 'none'
        })),
        state('show', style({
            display: 'block'
        })),
        transition('hide => show', [
            style({
                opacity: 0,
                position: 'absolute',
                left: 0,
                top: 0,
                transform: 'translateY(-50%)',
                'will-change': 'transform'
            }),
            animate('1s ease-out', style({
                opacity: 1,
                transform: 'translateY(0%)'
            }))
        ]),
        transition('show => hide', [
            style({
                position: 'absolute',
                left: 0,
                top: 0,
                transform: 'translateY(0%)',
                'will-change': 'transform'
            }),
            animate('0.3s ease-out', style({
                opacity: 0,
                transform: 'translateY(-50%)'
            }))
        ])
    ]);

//sub menu animate
export const submenuAnimate = trigger('submenuAnimate', [
        state('hide', style({
            overflow: 'hidden',
            height : 0
        })),
        state('show', style({
            overflow: 'hidden',
            height : '180px'
        })),
        transition('hide => show', [
            style({
                height : 0
            }),
            animate('0.5s ease-out', style({
                height : '180px'
            }))
        ]),
        transition('show => hide', [
            style({
                height : '180px'
            }),
            animate('0.5s ease-out', style({
                height : 0
            }))
        ])
    ]);    

//sub contact form
export const contactFormAnimate = trigger('contactFormAnimate', [
        state('hide', style({
            overflow: 'hidden',
            height : 0,
        })),
        state('show', style({
            overflow: 'hidden',
            height : '255px',
        })),
        transition('show => hide', [
            style({
                height : '255px'
            }),
            animate('0.5s ease-out', style({
                height : 0
            }))
        ]),
        transition('hide => show', [
            style({
                height : 0
            }),
            animate('1s ease-out', style({
                height : '50px'
            }))
        ])
    ]);   

export const contactMobileShopFinder = trigger('contactMobileShopFinder', [
        state('hide', style({
            display: 'none'
        })),
        state('show', style({
            display: 'block'
        })),
        transition('hide => show', [
            style({
                opacity: 0,
                position: 'absolute',
                left: 0,
                top: 0,
                transform: 'translateY(-50%)',
                'will-change': 'transform'
            }),
            animate('1s ease-out', style({
                opacity: 1,
                transform: 'translateY(0%)'
            }))
        ]),
        transition('show => hide', [
            style({
                position: 'absolute',
                left: 0,
                top: 0,
                transform: 'translateY(0%)',
                'will-change': 'transform'
            }),
            animate('0.3s ease-out', style({
                opacity: 0,
                transform: 'translateY(-50%)'
            }))
        ])
    ]);

//custom Order page animate
export const customOrderPage =
    returned(
        [
            {
                //1680px
                'view' : mediaQuerys["1680px"].matches,
                'state' : trigger('customOrderPage', [           
                    transition(':enter', [
                        style({
                            opacity: 1,
                            position: 'fixed',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 2
                        }),
                        query('#custom-order-page .child-left', style({ width: 0 })),
                        query('#custom-order-page .fullImage',  
                            style({
                                transform: 'translate(0)'
                            })                     
                        ),
                        query('#custom-order-page .content-text, .shadow',             
                            style({
                                opacity: 0,
                                'will-change': 'opacity'
                            })
                        ),
                        query('.left-menu .icon-list li a, .left-menu .icon-list li button', style({
                            top: '-50px'
                        }), { optional: true}),
                        query('#custom-order-page svg circle', 
                            style({
                                opacity: 0,
                                transform: 'scale(0)',
                                'will-change': 'auto'
                            })
                        ),
                        //animate
                        query('#custom-order-page svg circle', 
                            animate("1s ease-out", keyframes([
                                style({ opacity: 0, offset: 0 }),
                                style({ transform: 'scale(0.01)', opacity: 1, offset: 0.2 }),
                                style({ transform: 'scale(1)', offset: 1 })
                            ])),{optional:true}
                        ),
                        query('.content-text .list-block-carpet', 
                            style({
                                top: '105%'
                            })
                        ),
                        group([
                            query('#circle-custom-order',             
                                animate("2s cubic-bezier(.61,.32,.36,1.01)", keyframes([
                                    style({ opacity: 1, offset: 0 }),
                                    style({ opacity: 1, offset: 0.3 }),
                                    style({ transform: 'translate(0)', offset: 0.35 }),
                                    style({ transform: 'translate(16%)', offset: 1 })
                                ])),{optional:true}
                            ),
                            query('#custom-order-page .shadow', animate('.5s 1s ease-out', 
                                style({
                                    opacity: 0.5
                                })
                            )),        
                            query('#custom-order-page .child-left', stagger(300, [
                                style({ width: '0px' }),
                                animate('1s ease-out', style({width: '50%'})),
                            ])),
                        ]),            
                        query('#custom-order-page .content-text',
                            animate(".4s ease-out", keyframes([
                                style({ opacity: 0,  transform: 'translateX(50px)' }),
                                style({ opacity: 1,  transform: 'translateX(0px)' })
                            ])),{optional:true}
                        ),
                        query('.content-text .list-block-carpet', animate('.5s 1s ease-out',
                            style({
                                top: '0%'
                            })
                        )),
                    ]),
                    transition(':leave', [
                        style({
                            opacity: 1,
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 1
                        }),
                        animate('0.2s ease-out', style({
                            opacity: 0              
                        }))
                    ])
                ])
            },
            {
                //1400px
                'view' : mediaQuerys["1400px"].matches,
                'state' : trigger('customOrderPage', [           
                    transition(':enter', [
                        style({
                            opacity: 1,
                            position: 'fixed',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 2
                        }),
                        query('#custom-order-page .child-left', style({ width: 0 })),
                        query('#circle-custom-order',  
                            style({
                                transform: 'translate(0)'
                            })                     
                        ),
                        query('#custom-order-page .content-text, .shadow',             
                            style({
                                opacity: 0,
                                'will-change': 'opacity'
                            })
                        ),
                        query('#custom-order-page svg circle', 
                            style({
                                opacity: 0,
                                transform: 'scale(0)',
                                'will-change': 'opacity'
                            })
                        ),
                        query('.content-text .list-block-carpet', 
                            style({
                                top: '105%'
                            })
                        ),
                        //animate
                        query('#custom-order-page svg circle', 
                            animate("1s ease-out", keyframes([
                                style({ opacity: 0, offset: 0 }),
                                style({ transform: 'scale(0.01)', opacity: 1, offset: 0.2 }),
                                style({ transform: 'scale(1)', offset: 1 })
                            ])),{optional:true}
                        ),
                        group([
                            query('#circle-custom-order',             
                                animate("2s", keyframes([
                                    style({ opacity: 1, offset: 0 }),
                                    style({ opacity: 1, offset: 0.3 }),
                                    style({ transform: 'translate(0)', offset: 0.35 }),
                                    style({ transform: 'translate(16%)', offset: 1 })
                                ])),{optional:true}
                            ),
                            query('#custom-order-page .shadow', animate('.5s 1s ease-out', 
                                style({
                                    opacity: 0.5
                                })
                            )),        
                            query('#custom-order-page .child-left', stagger(300, [
                                style({ width: '0px' }),
                                animate('1s ease-out', style({width: '50%'})),
                            ])),
                        ]),            
                        query('#custom-order-page .content-text',
                            animate(".4s ease-out", keyframes([
                                style({ opacity: 0,  transform: 'translateX(20px)' }),
                                style({ opacity: 1,  transform: 'translateX(0px)' })
                            ])),{optional:true}
                        ),
                        query('.content-text .list-block-carpet', animate('.5s 1s ease-out',
                            style({
                                top: '0%'
                            })
                        )),
                    ]),
                    transition(':leave', [
                        style({
                            opacity: 1,
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 1
                        }),
                        animate('0.2s ease-out', style({
                            opacity: 0              
                        }))
                    ])
                ])
            },
            {
                //500px
                'view' : mediaQuerys["500px"].matches,
                'state' : trigger('customOrderPage', [           
                    transition(':enter', [
                        style({
                            opacity: 1,
                            position: 'fixed',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 2
                        }),
                        query('#custom-order-page .child-left', style({ width: 0 })),
                        query('#circle-custom-order',  
                            style({
                                transform: 'translate(0)'
                            })                     
                        ),
                        query('#custom-order-page .content-text, .shadow',             
                            style({
                                opacity: 0,
                                'will-change': 'opacity'
                            })
                        ),
                        query('#custom-order-page svg circle', 
                            style({
                                opacity: 0,
                                transform: 'scale(0)',
                                'will-change': 'auto'
                            })
                        ),
                        query('.content-text .list-block-carpet', 
                            style({
                                transform: 'translateY(105%)',
                                'will-change': 'transform'
                            })
                        ),
                        //animate
                        query('#custom-order-page svg circle', 
                            animate("1s ease-out", keyframes([
                                style({ opacity: 0, offset: 0 }),
                                style({ transform: 'scale(0.01)', opacity: 1, offset: 0.2 }),
                                style({ transform: 'scale(1)', offset: 1 })
                            ])),{optional:true}
                        ),
                        group([
                            query('#circle-custom-order',             
                                animate("2s", keyframes([
                                    style({ opacity: 1, offset: 0 }),
                                    style({ opacity: 1, offset: 0.3 }),
                                    style({ transform: 'translate(0)', offset: 0.35 }),
                                    style({ transform: 'translate(16%)', offset: 1 })
                                ])),{optional:true}
                            ),
                            query('#custom-order-page .shadow', animate('.5s 1s ease-out', 
                                style({
                                    opacity: 0.5
                                })
                            )),        
                            query('#custom-order-page .child-left', stagger(300, [
                                style({ width: '0px' }),
                                animate('1s ease-out', style({width: '100%'})),
                            ])),
                        ]),            
                        query('#custom-order-page .content-text',
                            animate(".4s ease-out", keyframes([
                                style({ opacity: 0,  transform: 'translateX(20px)' }),
                                style({ opacity: 1,  transform: 'translateX(0px)' })
                            ])),{optional:true}
                        ),
                        query('.content-text .list-block-carpet', animate('.5s 1s ease-out',
                            style({
                                transform: 'translateY(0%)',
                            })
                        )),
                    ]),
                    transition(':leave', [
                        style({
                            opacity: 1,
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 1
                        }),
                        animate('0.2s ease-out', style({
                            opacity: 0              
                        }))
                    ])
                ])
            }
        ],
        //default
        trigger('customOrderPage', [           
            transition(':enter', [
                style({
                    opacity: 1,
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: '100%',
                    'z-index': 2
                }),
                query('#custom-order-page .child-left', style({ width: 0 })),
                query('#circle-custom-order',  
                    style({
                        transform: 'translate(0)'
                    })                     
                ),
                query('#custom-order-page .content-text, .shadow',             
                    style({
                        opacity: 0,
                        'will-change': 'opacity'
                    })
                ),
                query('#custom-order-page svg circle', 
                    style({
                        opacity: 0,
                        transform: 'scale(0)',
                        'will-change': 'auto'
                    })
                ),
                query('.content-text .list-block-carpet', 
                    style({
                        transform: 'translateY(105%)',
                    })
                ),
                //animate
                query('#custom-order-page svg circle', 
                    animate("1s ease-out", keyframes([
                        style({ opacity: 0, offset: 0 }),
                        style({ transform: 'scale(0.01)', opacity: 1, offset: 0.2 }),
                        style({ transform: 'scale(1)', offset: 1 })
                    ])),{optional:true}
                ),
                group([
                    query('#circle-custom-order',             
                        animate("2s", keyframes([
                            style({ opacity: 1, offset: 0 }),
                            style({ opacity: 1, offset: 0.3 }),
                            style({ transform: 'translateX(0)', offset: 0.35 }),
                            style({ transform: 'translateX(20%)', offset: 1 })
                        ])),{optional:true}
                    ),
                    query('#custom-order-page .shadow', animate('.5s 1s ease-out', 
                        style({
                            opacity: 0.5
                        })
                    )),        
                    query('#custom-order-page .child-left', stagger(300, [
                        style({ width: '0px' }),
                        
                        animate('1s ease-out', style({width: '57%'})),
                    ])),
                ]),            
                query('#custom-order-page .content-text',
                    animate(".4s ease-out", keyframes([
                        style({ opacity: 0,  transform: 'translateX(50px)' }),
                        style({ opacity: 1,  transform: 'translateX(0px)' })
                    ])),{optional:true}
                ),
                
                query('.content-text .list-block-carpet', animate('.5s 1s ease-out',
                    style({
                        transform: 'translateY(0%)',
                    })
                )),
            ]),
            transition(':leave', [
                style({
                    opacity: 1,
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: '100%',
                    'z-index': 1
                }),
                animate('0.2s ease-out', style({
                    opacity: 0              
                }))
            ])
        ])
    );


// page 404 animate
export const Page404 =
    returned(
        [],
        //default
        trigger('Page404', [           
            transition(':enter', [
                style({
                    opacity: 1,
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: '100%',
                    'z-index': 2
                }),
                query('#about-page .fullImage',  
                    style({
                        right: 0
                    })                     
                ),
                query('#about-page .content, .shadow',             
                    style({
                        opacity: 0,
                        'will-change': 'opacity'
                    })
                ),
                query('#about-page .shadow',             
                    style({
                        opacity: 0,
                        'will-change': 'opacity'
                    })
                ),
                query('#about-page svg circle', 
                    style({
                        opacity: 0, 
                        r: 0,
                        'will-change': 'auto'
                    })
                ),
                //animate
                query('#about-page svg circle', 
                    animate("1s ease-out", keyframes([
                        style({ opacity: 0, offset: 0 }),
                        style({ r: 0, opacity: 1, offset: 0.2 }),
                        style({ r: 2450, offset: 1 })
                    ]))
                ),
                group([
                    query('#circle-about',             
                        animate("2s cubic-bezier(.61,.32,.36,1.01)", keyframes([
                            style({ opacity: 1, offset: 0 }),
                            style({ opacity: 1, offset: 0.3 }),
                            style({ right: 0, offset: 0.35 }),
                            style({ right: 0, offset: 1 })
                        ]))
                    ),
                    query('#about-page .shadow', animate('.5s 1s ease-out', 
                        style({
                            opacity: 0.5
                        })
                    )),        
                ]),            
                query('#about-page .content',
                    animate(".4s ease-out", keyframes([
                        style({ opacity: 0 }),
                        style({ opacity: 1 })
                    ]))
                )
            ]),
            transition(':leave', [
                style({
                    opacity: 1,
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: '100%',
                    'z-index': 1
                }),
                animate('0.2s ease-out', style({
                    opacity: 0              
                }))
            ])
        ])
    );      

//about page animate
export const aboutPage =
    returned(
        [
            {
            //1680px
                'view' : mediaQuerys["1680px"].matches,
                'state' : trigger('aboutPage', [           
                    transition(':enter', [
                        style({
                            opacity: 1,
                            position: 'fixed',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 2
                        }),
                        query('#about-page .child-left', style({ width: 0 })),
                        query('#about-page .fullImage',  
                            style({
                                transform: 'translate(0)'
                            })                     
                        ),
                        query('#about-page .content-text, .shadow',             
                            style({
                                opacity: 0,
                                'will-change': 'opacity'
                            })
                        ),
                        query('#about-page .shadow',             
                            style({
                                opacity: 0,
                                'will-change': 'opacity'
                            })
                        ),
                        query('#about-page svg circle', 
                            style({
                                opacity: 0, 
                                transform: 'scale(0)',
                                'will-change': 'auto'
                            })
                        ),
                        //animate
                        query('#about-page svg circle', 
                            animate("1s ease-out", keyframes([
                                style({ opacity: 0, offset: 0 }),
                                style({ transform: 'scale(0.01)', opacity: 1, offset: 0.2 }),
                                style({ transform: 'scale(1)', offset: 1 })
                            ]))
                        ),
                        group([
                            query('#circle-about',             
                                animate("2s", keyframes([
                                    style({ opacity: 1, offset: 0 }),
                                    style({ opacity: 1, offset: 0.3 }),
                                    style({ transform: 'translate(0)', offset: 0.35 }),
                                    style({ transform: 'translate(16%)', offset: 1 })
                                ]))
                            ),
                            query('#about-page .shadow', animate('.5s 1s ease-out', 
                                style({
                                    opacity: 0.5
                                })
                            )),        
                            query('#about-page .child-left', stagger(300, [
                                style({ width: '0px' }),
                                animate('1s ease-out', style({width: '50%'})),
                            ])),
                        ]),            
                        query('#about-page .content-text',
                            animate(".4s ease-out", keyframes([
                                style({ opacity: 0,  transform: 'translateX(50px)' }),
                                style({ opacity: 1,  transform: 'translateX(0px)' })
                            ]))
                        )
                    ]),
                    transition(':leave', [
                        style({
                            opacity: 1,
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 1
                        }),
                        animate('0.2s ease-out', style({
                            opacity: 0              
                        }))
                    ])
                ])
            },
            {
                //1400px
                'view' : mediaQuerys["1400px"].matches,
                'state' : trigger('aboutPage', [           
                    transition(':enter', [
                        style({
                            opacity: 1,
                            position: 'fixed',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 2
                        }),
                        query('#about-page .child-left', style({ width: 0 })),
                        query('#about-page .fullImage',  
                            style({
                                transform: 'translate(0)',
                                'will-change': 'opacity'
                            })                     
                        ),
                        query('#about-page .content-text, .shadow',             
                            style({
                                opacity: 0,
                                'will-change': 'opacity'
                            })
                        ),
                        query('#about-page svg circle', 
                            style({
                                opacity: 0,
                                transform: 'scale(0)',
                                'will-change': 'auto'
                            })
                        ),
                        //animate
                        query('#about-page svg circle', 
                            animate("1s ease-out", keyframes([
                                style({ opacity: 0, offset: 0 }),
                                style({ transform: 'scale(0.01)', opacity: 1, offset: 0.2 }),
                                style({ transform: 'scale(1)', offset: 1 })
                            ])),{optional:true}
                        ),
                        group([
                            query('#circle-about',             
                                animate("2s", keyframes([
                                    style({ opacity: 1, offset: 0 }),
                                    style({ opacity: 1, offset: 0.3 }),
                                    style({ transform: 'translate(0)', offset: 0.35 }),
                                    style({ transform: 'translate(16%)', offset: 1 })
                                ])),{optional:true}
                            ),
                            query('#about-page .shadow', animate('.5s 1s ease-out', 
                                style({
                                    opacity: 0.5
                                })
                            )),        
                            query('#about-page .child-left', stagger(300, [
                                style({ width: '0px' }),
                                animate('1s ease-out', style({width: '50%'})),
                            ])),
                        ]),            
                        query('#about-page .content-text',
                            animate(".4s ease-out", keyframes([
                                style({ opacity: 0,  transform: 'translateX(20px)' }),
                                style({ opacity: 1,  transform: 'translateX(0px)' })
                            ])),{optional:true}
                        )
                    ]),
                    transition(':leave', [
                        style({
                            opacity: 1,
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 1
                        }),
                        animate('0.2s ease-out', style({
                            opacity: 0              
                        }))
                    ])
                ])
            },
            {
                //1400px
                'view' : mediaQuerys["1300px"].matches,
                'state' : trigger('aboutPage', [           
                    transition(':enter', [
                        style({
                            opacity: 1,
                            position: 'fixed',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 2
                        }),
                        query('#about-page .child-left', style({ width: 0 })),
                        query('#about-page .fullImage',  
                            style({
                                transform: 'translate(0)'
                            })                     
                        ),
                        query('#about-page .content-text, .shadow',             
                            style({
                                opacity: 0,
                                'will-change': 'opacity'
                            })
                        ),
                        query('#about-page svg circle', 
                            style({
                                opacity: 0,
                                transform: 'scale(0)',
                                'will-change': 'auto'
                            })
                        ),
                        //animate
                        query('#about-page svg circle', 
                            animate("1s ease-out", keyframes([
                                style({ opacity: 0, offset: 0 }),
                                style({ transform: 'scale(0.01)', opacity: 1, offset: 0.2 }),
                                style({ transform: 'scale(1)', offset: 1 })
                            ])),{optional:true}
                        ),
                        group([
                            query('#circle-about',             
                                animate("2s", keyframes([
                                    style({ opacity: 1, offset: 0 }),
                                    style({ opacity: 1, offset: 0.3 }),
                                    style({ transform: 'translate(0%)', offset: 0.35 }),
                                    style({ transform: 'translate(16%)', offset: 1 })
                                ])),{optional:true}
                            ),
                            query('#about-page .shadow', animate('.5s 1s ease-out', 
                                style({
                                    opacity: 0.5
                                })
                            )),        
                            query('#about-page .child-left', stagger(300, [
                                style({ width: '0px' }),
                                animate('1s ease-out', style({width: '59%'})),
                            ])),
                        ]),            
                        query('#about-page .content-text',
                            animate(".4s ease-out", keyframes([
                                style({ opacity: 0,  transform: 'translateX(20px)' }),
                                style({ opacity: 1,  transform: 'translateX(0px)' })
                            ])),{optional:true}
                        )
                    ]),
                    transition(':leave', [
                        style({
                            opacity: 1,
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 1
                        }),
                        animate('0.2s ease-out', style({
                            opacity: 0              
                        }))
                    ])
                ])
            },
            {
                //500px
                'view' : mediaQuerys["500px"].matches,
                'state' : trigger('aboutPage', [           
                    transition(':enter', [
                        style({
                            opacity: 1,
                            position: 'fixed',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 2
                        }),
                        query('#about-page .child-left', style({ width: 0 })),
                        query('#about-page .fullImage',  
                            style({
                                transform: 'translate(0)'
                            }),{optional:true}                     
                        ),
                        query('#about-page .content-text, .shadow',             
                            style({
                                opacity: 0,
                                'will-change': 'opacity'
                            })
                        ),
                        query('#about-page svg circle', 
                            style({
                                opacity: 0,
                                transform : 'translate(0)',
                                'will-change': 'auto'
                            }),{optional:true}
                        ),
                        query('.bg-image', 
                            style({
                                opacity: 0
                            }),{optional:true}
                        ),
                        
                        //animate
                        query('#about-page svg circle', 
                            animate("1s ease-out", keyframes([
                                style({ opacity: 0, offset: 0 }),
                                style({ transform: 'scale(0.01)', opacity: 1, offset: 0.2 }),
                                style({ transform: 'scale(1)', offset: 1 })
                            ])),{optional:true}
                        ),
                        group([
                            query('.bg-image',             
                                animate("1s", keyframes([
                                    style({ opacity: 0, offset: 0 }),
                                    style({ opacity: 1, offset: 1 })
                                ])),{optional:true}
                            ),
                            query('#circle-about',             
                                animate("2s", keyframes([
                                    style({ opacity: 0, offset: 0 }),
                                    style({ opacity: 1, offset: 1 })
                                ])),{optional:true}
                            ),
                            query('#about-page .shadow', animate('.5s 1s ease-out', 
                                style({
                                    opacity: 0.5
                                })
                            )),        
                            query('#about-page .child-left', stagger(300, [
                                style({ width: '0px' }),
                                animate('1s ease-out', style({width: '100%'})),
                            ])),
                        ]),            
                        query('#about-page .content-text',
                            animate(".4s ease-out", keyframes([
                                style({ opacity: 0,  transform: 'translateX(20px)' }),
                                style({ opacity: 1,  transform: 'translateX(0px)' })
                            ])),{optional:true}
                        )
                    ]),
                    transition(':leave', [
                        style({
                            opacity: 1,
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 1
                        }),
                        animate('0.2s ease-out', style({
                            opacity: 0              
                        }))
                    ])
                ])
            }
        ],
        //default
        trigger('aboutPage', [           
            transition(':enter', [
                style({
                    opacity: 1,
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: '100%',
                    'z-index': 2
                }),
                query('#about-page .child-left', style({ width: 0 })),
                query('#about-page .fullImage',  
                    style({
                        transform: 'translateX(0)',
                        'will-change': 'transform'
                    })                     
                ),
                query('#about-page .content-text, .shadow',             
                    style({
                        opacity: 0,
                        'will-change': 'opacity'
                    })
                ),
                query('#about-page .shadow',             
                    style({
                        opacity: 0,
                        'will-change': 'opacity'
                    })
                ),
                query('#about-page svg circle', 
                    style({
                        opacity: 0, 
                        transform: 'scale(0)',
                        'will-change': 'auto'
                    })
                ),
                //animate
                query('#about-page svg circle', 
                    animate("1s ease-out", keyframes([
                        style({ opacity: 0, offset: 0 }),
                        style({ transform: 'scale(0.01)', opacity: 1, offset: 0.2 }),
                        style({ transform: 'scale(1)', offset: 1 })
                    ]))
                ),
                group([
                    query('#circle-about',             
                        animate("2s", keyframes([
                            style({ opacity: 1, offset: 0 }),
                            style({ opacity: 1, offset: 0.3 }),
                            style({ transform: 'translateX(0)', offset: 0.35 }),
                            style({ transform: 'translateX(20%)', offset: 1 })
                        ]))
                    ),
                    query('#about-page .shadow', animate('.5s 1s ease-out', 
                        style({
                            opacity: 0.5
                        })
                    )),        
                    query('#about-page .child-left', stagger(300, [
                        style({ width: '0px' }),
                        animate('1s ease-out', style({width: '57%'})),
                    ])),
                ]),            
                query('#about-page .content-text',
                    animate(".4s ease-out", keyframes([
                        style({ opacity: 0,  transform: 'translateX(30px)' }),
                        style({ opacity: 1,  transform: 'translateX(0px)' })
                    ]))
                )
            ]),
            transition(':leave', [
                style({
                    opacity: 1,
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: '100%',
                    'z-index': 1
                }),
                animate('0.2s ease-out', style({
                    opacity: 0              
                }))
            ])
        ])
    );     

//blog page page animate
export const qualityAnimatePage =
        //default
        trigger('qualityAnimatePage', [           
            transition(':enter', [
                style({
                    opacity: 1,
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: '100%',
                    'z-index': 2
                }),
                query('#quality-page svg circle', 
                    style({
                        opacity: 0,
                        transform: 'scale(0)',
                        'will-change': 'auto'
                    })
                ),
                query('#quality-page .shadow', 
                    style({
                        opacity: 0,
                        'will-change': 'opacity'
                    })
                ),
                query('.quality-page .content-block .item', 
                    style({
                        opacity: 0,
                        transform: 'translateX(200px)',
                        'will-change': 'opacity, transform'
                    })
                ),
                query('.quality-page .video-area', 
                    style({
                        opacity: 0,
                        'will-change': 'opacity'
                    })
                ),
                query('.content-block', 
                    style({
                        overflow: 'hidden'
                    })
                ),               
                //animate
                query('#quality-page svg circle', 
                    animate("1s ease-out", keyframes([
                        style({ opacity: 0, offset: 0 }),
                        style({ transform: 'scale(0.01)', opacity: 1, offset: 0.2 }),
                        style({ transform: 'scale(1)', offset: 1 })
                    ])),{optional:true}
                ),   
                query('#quality-page .shadow', animate("0.5s ease-out",
                    style({
                        opacity: 0.5,
                    })
                )),  
                query('.quality-page .content-block .item', animate("1s ease-out",
                    style({
                        opacity: 1,
                        transform: 'translateX(0px)'
                    })
                )),
                query('.quality-page .video-area', animate("1s ease-out",
                    style({
                        opacity: 1
                    })
                )),
            ]),
            transition(':leave', [
                style({
                    opacity: 1,
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: '100%',
                    'z-index': 1
                }),
                animate('0.2s ease-out', style({
                    opacity: 0              
                }))
            ])
        ]); 
         
//blog page animate anchored animate
export const sliderPage = 
        trigger('sliderPage', [
            state('normal', style({
                opacity: 1,
                transform: 'translateX(0)'
            })),
            state('hide', style({
                opacity: 0,
                transform: 'translateX(800px)'
            })),
            transition('hide => normal', [
                style({
                    opacity: 0,
                    transform: 'translateX(800px)',
                    'will-change': 'transform'
                }),
                query('.homeCollection .item', style({
                    transform: 'translateX(80px)',
                    'will-change': 'transform'
                })),
                //animate
                group([
                    animate('0.5s ease-out', style({
                        opacity: 1,
                        transform: 'translateX(0)'
                    })),
                    query('.homeCollection .item', stagger(100, [
                        animate('0.6s ease-out', style({ 
                            transform: 'translateX(0)' 
                        }))
                    ])),
                ])
                
            ])
        ]);                

//fair page animate
export const fairAnimatePage =
        //default
        trigger('fairAnimatePage', [           
            transition(':enter', [
                style({
                    opacity: 1,
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: '100%',
                    'z-index': 2
                }),
                query('#fair-page svg circle', 
                    style({
                        opacity: 0,
                        transform: 'scale(0)',
                        'will-change': 'auto'
                    })
                ),
                query('#fair-page .content-slide .item, .slick-dots', 
                    style({
                        opacity: 0,
                        transform: 'translateX(200px)',
                        'will-change': 'transform, opacity'
                    })
                ),
                //animate
                query('#fair-page svg circle', 
                    animate("1.2s ease-out", keyframes([
                        style({ opacity: 0, offset: 0 }),
                        style({ transform: 'scale(0.01)', opacity: 1, offset: 0.2 }),
                        style({ transform: 'scale(1)', offset: 1 })
                    ])),{optional:true}
                ),     
                query('#fair-page .content-slide .item, .slick-dots', animate("1s ease-out",
                    style({
                        opacity: 1,
                        transform: 'translateX(0px)'
                    })
                )),
            ]),
            transition(':leave', [
                style({
                    opacity: 1,
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: '100%',
                    'z-index': 1
                }),
                animate('0.2s ease-out', style({
                    opacity: 0              
                }))
            ])
        ]);         
    
//contact page animate
export const contactAnimatePage =
    returned(
        [],
        //default
        trigger('contactAnimatePage', [           
            transition(':enter', [
                style({
                    opacity: 1,
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: '100%',
                    'z-index': 2
                }),  
                query('#theMask-contact-page rect', 
                    style({
                        width: 0,
                        'background-color': 'red'
                    })
                ),
                query('.contact-page .contact-sec .scroll-area',
                    style({
                        overflow: 'hidden'
                    })
                ),
                query('#contact-page .map-sec', 
                    style({
                        opacity: 0,
                        'will-change': 'opacity'
                    })
                ),
                query('#contact-page .contact-sec .info',
                    style({
                        transform: 'translateX(50px)',
                        opacity: 0,
                        'will-change': 'transform, opacity'
                    })
                ),
                query('#contact-page .contact-sec .search-sec',
                    style({
                        transform: 'translateY(50px)',
                        opacity: 0,
                        'will-change': 'transform, opacity'
                    })
                ),
                //animate
                query('#theMask-contact-page rect', 
                    animate("1s ease-out", style({
                        width: '100%',
                        opacity: 1
                    }))
                ),
                group([
                    query('#contact-page .contact-sec .info',
                        animate(".6s ease-out", 
                            style({
                                transform: 'translateX(0%)',
                                opacity: 1
                            })
                        )
                    ),
                    query('#contact-page .contact-sec .search-sec',
                        animate("1s ease-out", 
                            style({
                                transform: 'translateX(0px)',
                                opacity: 1
                            })
                        )
                    )
                ]),
                query('#contact-page .map-sec', animate(".6s ease-out", 
                    style({
                        opacity: 1
                    })
                ))
            ]),
            transition(':leave', [
                style({
                    opacity: 1,
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: '100%',
                    'z-index': 1
                }),
                animate('0.2s ease-out', style({
                    opacity: 0              
                }))
            ])
        ])
    );   

//contact page animate
export const designerAnimatePage =
    returned(
        [
            {
                //500px
                'view' : mediaQuerys["500px"].matches,
                'state' : trigger('designerAnimatePage', [           
                    transition(':enter', [
                        style({
                            opacity: 1,
                            position: 'fixed',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 2
                        }),  
                        query('#rectangle-designers', 
                            style({
                                position: 'absolute',
                                height: '100%',
                                width: '100%'
                            })
                        ),
                        query('#theMask-designers-page rect', 
                            style({
                                width: 0,
                                height: '300%'
                            })
                        ),
                        query('.designers .hide-area', 
                            style({
                                transform: 'translate(0, -100%)',
                                'will-change': 'transform'
                            })
                        ),
                        query('.designers .designers-slider .item', 
                            style({
                                'opacity': 0,
                                'will-change': 'opacity'
                            })
                        ), 
                        //animate
                        query('#designers-page .svgBlockStyle', 
                            animate("1s ease-out", 
                                style({
                                    width: '100%'
                                })
                            )
                        ),
                        query('.designers .designers-slider .item', 
                            style({
                                'opacity': 1
                            })
                        ), 
                        query('#theMask-designers-page rect', 
                            style({
                                width: 0
                            })
                        ),
                        group([
                            query('.designers .item .top-line', 
                                animate("1s ease-out", 
                                    style({
                                        top: '-100%'
                                    })
                                )
                            ),
                            query('.designers .item .bottom-line', 
                                animate("1s ease-out", 
                                    style({
                                        bottom: '-100%'
                                    })
                                )
                            ),
                            query('.designers .title .hide-area', 
                                animate("0.6s ease-out", 
                                    style({
                                        transform: 'translate(0, 0%)'
                                    })
                                )
                            ),
                            query('.designers .text .hide-area', 
                                animate("0.7s ease-out", 
                                    style({
                                        transform: 'translate(0, 0%)'
                                    })
                                )
                            ),
                        ]),
                        
                    ]),
                    transition(':leave', [
                        style({
                            opacity: 1,
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 1
                        }),
                        animate('0.2s ease-out', style({
                            opacity: 0              
                        }))
                    ])
                ])
            }
        ],
        //default
        trigger('designerAnimatePage', [           
            transition(':enter', [
                style({
                    opacity: 1,
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: '100%',
                    'z-index': 2
                }),  
                query('#rectangle-designers', 
                    style({
                        position: 'absolute',
                        height: '100%',
                        width: '100%'
                    })
                ),
                query('#theMask-designers-page rect', 
                    style({
                        width: 0
                    })
                ),
                query('.designers .hide-area', 
                    style({
                        transform: 'translate(0, -100%)',
                        'will-change': 'transform'
                    })
                ),
                query('.designers .designers-slider .item', 
                    style({
                        'opacity': 0,
                        'will-change': 'opacity'
                    })
                ), 
                //animate
                query('#theMask-designers-page rect', 
                    animate("1.2s ease-out", 
                        style({
                            width: '100%'
                        })
                    )
                ),
                query('.designers .designers-slider .item', 
                    style({
                        'opacity': 1
                    })
                ), 
                query('#theMask-designers-page rect', 
                    style({
                        width: 0
                    })
                ),
                group([
                    query('.designers .item .top-line', 
                        animate("1s ease-out", 
                            style({
                                top: '-100%'
                            })
                        )
                    ),
                    query('.designers .item .bottom-line', 
                        animate("1s ease-out", 
                            style({
                                bottom: '-100%'
                            })
                        )
                    ),
                    query('.designers .title .hide-area', 
                        animate("0.6s ease-out", 
                            style({
                                transform: 'translate(0, 0%)'
                            })
                        )
                    ),
                    query('.designers .text .hide-area', 
                        animate("0.7s ease-out", 
                            style({
                                transform: 'translate(0, 0%)'
                            })
                        )
                    ),
                ]),
                
            ]),
            transition(':leave', [
                style({
                    opacity: 1,
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: '100%',
                    'z-index': 1
                }),
                animate('0.2s ease-out', style({
                    opacity: 0              
                }))
            ])
        ])
    );     

//post designer
export const postDesigner = 
    returned(
        [
            {
                //1680px
                'view' : mediaQuerys["1680px"].matches,
                'state' : trigger('postDesigner', [
                    transition(':enter', [
                        style({
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 2
                        }),
                        query('#post-designer h1', 
                            style({
                                opacity: 0,
                                'will-change': 'opacity'
                            })
                        ),
                        query('#post-designer .content-text', 
                            style({
                                opacity: 0,
                                transform: 'translateX(50px)',
                                'will-change': 'transform, opacity'
                            })
                        ),
                        query('#post-designer h1', 
                            style({
                                opacity: 0,
                                transform: 'translateY(-30px)',
                                'will-change': 'transform, opacity'
                            })
                        ),
                        query('.shadow', style({
                            opacity: 1,
                            'will-change': 'opacity'
                        })),
                        query('#post-designer h1 b', 
                            style({
                                opacity: 0,
                                transform: 'translateY(-30px)',
                                'will-change': 'transform, opacity'
                            })
                        ),
                        //animate
                        group([
                            query('.design .image', animate("1s cubic-bezier(.61,.32,.36,1.01)",
                                style({
                                    transform: 'translateX(160px)'
                                }))   
                            )
                        ]),
                        query('.shadow', animate("0.6s cubic-bezier(.61,.32,.36,1.01)", style({
                            opacity: 1,
                            'will-change': 'opacity'
                        }))),
                        query('#post-designer h1', animate(".5s ease-out",
                            style({
                                opacity: 1,
                                transform: 'translateY(-0px)'
                            }))
                        ),
                        query('#post-designer h1 b', animate(".5s ease-out",
                            style({
                                opacity: 1,
                                transform: 'translateY(-0px)'
                            }))
                        ),
                        query('#post-designer .content-text', animate("0.5s ease-out",
                            style({
                                opacity: 1,
                                transform: 'translateX(0px)'
                            }))
                        ),
                    ]),
                    transition(':leave', [
                        style({
                            opacity: 1,
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 1
                        }),
                        animate('1s ease-out', style({
                            opacity: 0
                        }))
                    ])
                ])
            },
            {
                //1000px
                'view' : mediaQuerys["1000px"].matches,
                'state' : trigger('postDesigner', [
                    transition(':enter', [
                        style({
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 2
                        }),
                        query('#post-designer h1', 
                            style({
                                opacity: 0,
                                'will-change': 'opacity'
                            })
                        ),
                        query('#post-designer .content-text', 
                            style({
                                opacity: 0,
                                transform: 'translateX(50px)',
                                'will-change': 'transform, opacity'
                            })
                        ),
                        query('#post-designer h1', 
                            style({
                                opacity: 0,
                                transform: 'translateY(-30px)',
                                'will-change': 'transform, opacity'
                            })
                        ),
                        query('.shadow', style({
                            opacity: 1,
                            'will-change': 'opacity'
                        })),
                        query('#post-designer h1 b', 
                            style({
                                opacity: 0,
                                transform: 'translateY(-30px)',
                                'will-change': 'transform, opacity'
                            })
                        ),
                        //animate
                        group([
                            query('.design .image', animate("1s cubic-bezier(.61,.32,.36,1.01)",
                                style({
                                    transform: 'translateX(200px)'
                                }))   
                            )
                        ]),
                        query('.shadow', animate("0.6s cubic-bezier(.61,.32,.36,1.01)", style({
                            opacity: 1,
                            'will-change': 'opacity'
                        }))),
                        query('#post-designer h1', animate(".5s ease-out",
                            style({
                                opacity: 1,
                                transform: 'translateY(-0px)'
                            }))
                        ),
                        query('#post-designer h1 b', animate(".5s ease-out",
                            style({
                                opacity: 1,
                                transform: 'translateY(-0px)'
                            }))
                        ),
                        query('#post-designer .content-text', animate("0.5s ease-out",
                            style({
                                opacity: 1,
                                transform: 'translateX(0px)'
                            }))
                        ),
                    ]),
                    transition(':leave', [
                        style({
                            opacity: 1,
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 1
                        }),
                        animate('1s ease-out', style({
                            opacity: 0
                        }))
                    ])
                ])
            },
            {
                //800px
                'view' : mediaQuerys["800px"].matches,
                'state' : trigger('postDesigner', [
                    transition(':enter', [
                        style({
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 2
                        }),
                        query('#post-designer h1', 
                            style({
                                opacity: 0,
                                'will-change': 'opacity'
                            })
                        ),
                        query('#post-designer .content-text', 
                            style({
                                opacity: 0,
                                transform: 'translateX(50px)',
                                'will-change': 'transform, opacity'
                            })
                        ),
                        query('#post-designer h1', 
                            style({
                                opacity: 0,
                                transform: 'translateY(-30px)',
                                'will-change': 'transform, opacity'
                            })
                        ),
                        query('.shadow', style({
                            opacity: 1,
                            'will-change': 'opacity'
                        })),
                        query('#post-designer h1 b', 
                            style({
                                opacity: 0,
                                transform: 'translateY(-30px)',
                                'will-change': 'transform, opacity'
                            })
                        ),
                        //animate
                        group([
                            query('.design .image', animate("1s cubic-bezier(.61,.32,.36,1.01)",
                                style({
                                    transform: 'translateX(55px)'
                                }))   
                            )
                        ]),
                        query('.shadow', animate("0.6s cubic-bezier(.61,.32,.36,1.01)", style({
                            opacity: 1,
                            'will-change': 'opacity'
                        }))),
                        query('#post-designer h1', animate(".5s ease-out",
                            style({
                                opacity: 1,
                                transform: 'translateY(-0px)'
                            }))
                        ),
                        query('#post-designer h1 b', animate(".5s ease-out",
                            style({
                                opacity: 1,
                                transform: 'translateY(-0px)'
                            }))
                        ),
                        query('#post-designer .content-text', animate("0.5s ease-out",
                            style({
                                opacity: 1,
                                transform: 'translateX(0px)'
                            }))
                        ),
                    ]),
                    transition(':leave', [
                        style({
                            opacity: 1,
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 1
                        }),
                        animate('1s ease-out', style({
                            opacity: 0
                        }))
                    ])
                ])
            },
            {
                'view' : mediaQuerys["500px"].matches,
                'state' : trigger('postDesigner', [
                    transition(':enter', [
                        style({
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 2
                        }),
                        query('#post-designer h1', 
                            style({
                                opacity: 0,
                                'will-change': 'opacity'
                            })
                        ),
                        query('#post-designer .content-text', 
                            style({
                                opacity: 0,
                                transform: 'translateX(50px)',
                                'will-change': 'transform, opacity'
                            })
                        ),
                        query('#post-designer h1', 
                            style({
                                opacity: 0,
                                transform: 'translateY(-30px)',
                                'will-change': 'transform, opacity'
                            })
                        ),
                        query('#post-designer h1 b', 
                            style({
                                opacity: 0,
                                transform: 'translateY(-30px)',
                                'will-change': 'transform, opacity'
                            })
                        ),
                        query('.shadow', style({
                            opacity: 1,
                            'will-change': 'opacity'
                        })),
                        query('.design .content .inside-width', style({
                            opacity: 0,
                            transform: 'translateY(-50%)',
                            'will-change': 'transform, opacity'
                        })),
                        //animate
                        group([
                            query('.design .image', animate("1s cubic-bezier(.61,.32,.36,1.01)",
                                style({
                                    transform: 'translateX(55px)'
                                }))   
                            )
                        ]),
                        query('.shadow', animate("0.6s cubic-bezier(.61,.32,.36,1.01)", style({
                            opacity: 1,
                            'will-change': 'opacity'
                        }))),
                        query('.design .content .inside-width', animate('.5s ease-out', style({
                            opacity: 1,
                            transform: 'translateY(0%)'
                        }))),
                        query('#post-designer h1', animate(".5s ease-out",
                            style({
                                opacity: 1,
                                transform: 'translateY(-0px)'
                            }))
                        ),
                        query('#post-designer h1 b', animate(".5s ease-out",
                            style({
                                opacity: 1,
                                transform: 'translateY(-0px)'
                            }))
                        ),
                        query('#post-designer .content-text', animate("0.5s ease-out",
                            style({
                                opacity: 1,
                                transform: 'translateX(0px)'
                            }))
                        ),
                    ]),
                    transition(':leave', [
                        style({
                            opacity: 1,
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 1
                        }),
                        animate('1s ease-out', style({
                            opacity: 0
                        }))
                    ])
                ])
            }
        ],
        trigger('postDesigner', [
            transition(':enter', [
                style({
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                    'z-index': 2
                }),
                query('#post-designer h1', 
                    style({
                        opacity: 0,
                        'will-change': 'opacity'
                    })
                ),
                query('#post-designer .content-text', 
                    style({
                        opacity: 0,
                        transform: 'translateX(50px)',
                        'will-change': 'transform, opacity'
                    })
                ),
                query('#post-designer h1', 
                    style({
                        opacity: 0,
                        transform: 'translateY(-30px)',
                        'will-change': 'transform, opacity'
                    })
                ),
                query('#post-designer h1 b', 
                    style({
                        opacity: 0,
                        transform: 'translateY(-30px)',
                        'will-change': 'transform, opacity'
                    })
                ),
                //animate
                group([
                    query('.design .image', animate("1s cubic-bezier(.61,.32,.36,1.01)",
                        style({
                            transform: 'translateX(250px)'
                        }))   
                    )
                ]),
                query('#post-designer h1', animate(".5s ease-out",
                    style({
                        opacity: 1,
                        transform: 'translateY(-0px)'
                    }))
                ),
                query('#post-designer h1 b', animate(".5s ease-out",
                    style({
                        opacity: 1,
                        transform: 'translateY(-0px)'
                    }))
                ),
                query('#post-designer .content-text', animate("0.5s ease-out",
                    style({
                        opacity: 1,
                        transform: 'translateX(0px)'
                    }))
                ),
            ]),
            transition(':leave', [
                style({
                    opacity: 1,
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: '100%',
                    'z-index': 1
                }),
                animate('1s ease-out', style({
                    opacity: 0
                }))
            ])
        ])
    );      
    
//contact form page page animate
export const contactAnimatePageForm =
    returned(
        [],
        //default
        trigger('contactAnimatePageForm', [           
            transition(':enter', [
                style({
                    opacity: 1,
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: '100%',
                    'z-index': 2
                }),  
                
                query('#theMask-contact-page-form rect', 
                    style({
                        height: 0
                    })
                ),
                query('#contact-form-page .right', 
                    style({
                        opacity: 0,
                        'will-change': 'opacity'
                    })
                ),
                query('#contact-form-page .left',
                    style({
                        transform: 'translateY(50px)',
                        opacity: 0,
                        'will-change': 'transform, opacity'
                    })
                ),
                //animate
                query('#theMask-contact-page-form rect', 
                    animate("0.5s ease-out", style({
                        height: '100%'
                    }))
                ),
                group([
                    query('#contact-form-page .left',
                        animate(".6s ease-out", 
                            style({
                                transform: 'translateX(0%)',
                                opacity: 1
                            })
                        )
                    ),
                    query('#contact-form-page .right',
                        animate("1s ease-out", 
                            style({
                                opacity: 1
                            })
                        )
                    )
                ])
            ]),
            transition(':leave', [
                style({
                    opacity: 1,
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: '100%',
                    'z-index': 1
                }),
                animate('0.2s ease-out', style({
                    opacity: 0              
                }))
            ])
        ])
    ); 
    
//post page animate
export const postPageAnimate =
    returned(
        [],
        //default
        trigger('postPageAnimate', [           
            transition(':enter', [
                style({
                    opacity: 1,
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: '100%',
                    'z-index': 2
                }),  
                query('.post-page .head-post', 
                    style({
                        opacity: 0,
                        transform: 'translateY(-200px)',
                        'will-change': 'transform, opacity'
                    })
                ),
                query('.post-page .content-post', 
                    style({
                        opacity: 0,
                        transform: 'translateY(250px)',
                        'will-change': 'transform, opacity'
                    })
                ),

                //animate
                query('#post rect', 
                    animate("0.8s ease", style({
                        height: '100%',
                        width: '100%',
                        transform: 'translate(0,0)'
                    }))               
                ),
                group([
                    query('.post-page .head-post', animate(".6s ease-out",
                        style({
                            opacity: 1,
                            transform: 'translateY(0px)',
                        }))
                    ),
                    query('.post-page .content-post', animate("1.2s ease-out",
                        style({
                            opacity: 1,
                            transform: 'translateY(0px)',
                        }))
                    ),
                ])
            ]),
            transition(':leave', [
                style({
                    opacity: 1,
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: '100%',
                    'z-index': 1
                }),
                animate('0.2s ease-out', style({
                    opacity: 0              
                }))
            ])
        ])
    );    

//home page animate
export const homePage =
    trigger('homePage', [
        transition(':enter', [
            style({
                opacity: 0,
                position: 'fixed',
                top: 0,
                left: 0,
                height: '100%',
                width: '100%',
                'z-index': 2
            }),
            animate('1s ease-out', style({
                opacity: 1,
            }))
        ]),
        transition(':leave', [
            style({
                opacity: 1,
                position: 'absolute',
                left: 0,
                top: 0,
                height: '100%',
                width: '100%',
                'z-index': 1
            }),
            animate('1s ease-out', style({
                opacity: 0
            }))
        ])
    ]);    

//collection page animate
export const collectionPage = 
    returned(
        [

        ],
        trigger('collectionPage', [
            transition(':enter', [
                style({
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                    'z-index': 2
                }),
                query('#collection-page svg circle, #about-page svg circle, #press-page svg circle', 
                    style({
                        'will-change': 'auto',
                        opacity: 0,
                        transform: 'scale(0)'
                    })
                ),
                query('#collection-page .slider-content, #about-page .slider-content, #press-page .slider-content', 
                    style({
                        'will-change': 'transform',
                        transform: 'translateX(100%)'
                    })
                ),
                query('#collection-page .slider-content .item, #about-page .slider-content .item, #press-page .slider-content .item',
                    style({
                        'will-change': 'transform',
                        transform: 'translateX(90px)'
                    })
                ),
                //animate
                query('#collection-page svg circle, #about-page svg circle, #press-page svg circle', 
                    animate("1s ease-in-out", keyframes([
                        style({ opacity: 0, offset: 0 }),
                        style({ transform: 'scale(0.01)', opacity: 1, offset: 0.2 }),
                        style({ transform: 'scale(1)', offset: 1 })
                    ])),{optional:true}
                ),
                group([
                    query('#collection-page .slider-content, #about-page .slider-content, #press-page .slider-content',
                        animate("0.5s ease-out", 
                            style({
                                transform: 'translateX(0%)'
                            })
                        )
                    ),
                    query('#collection-page .slider-content .item, #about-page .slider-content .item, #press-page .slider-content .item', stagger(100, [
                        animate("0.6s ease-out", 
                            style({
                                transform: 'translateX(0px)'
                            })
                        )
                    ]))
                ])
            ]),
            transition(':leave', [
                style({
                    opacity: 1,
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: '100%',
                    'z-index': 1
                }),
                animate('1s ease-out', style({
                    opacity: 0
                }))
            ])
        ])
    );  


//collection post animate
export const collectionPost = 
    returned(
        [
            {
                'view' : mediaQuerys["1680px"].matches,
                'state' : trigger('collectionPost', [
                    transition(':enter', [
                        style({
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 2
                        }),        
                        query('#masker-collection-post', 
                            style({
                                transform: 'scale(0)',
                                'will-change': 'auto'
                            })
                        ),    
                        query('.collection-post .right', 
                            style({
                                opacity: 0,
                                width: '65%',
                                transform: 'translateX(100%)',
                                'will-change': 'auto'
                            })
                        ),
                        query('.collection-post .right .content .width', 
                            style({
                                opacity: 0,
                                transform: 'translateY(200px)',
                                'will-change': 'auto'
                            })
                        ),
                        query('.collection-post .right .list-block-carpet', 
                            style({
                                transform: 'translateY(105%)',
                                'will-change': 'transform'
                            })
                        ),
                        query('.collection-post .slider-images-bg', 
                            style({
                                opacity: 0,
                                'will-change': 'opacity'
                            }),{optional:true} 
                        ),

                        //animate
                        group([  
                            query('#masker-collection-post', 
                                animate("1s ease-out", keyframes([
                                    style({ opacity: 0, offset: 0 }),
                                    style({ transform: 'scale(0.01)', opacity: 1, offset: 0.2 }),
                                    style({ transform: 'scale(1)', offset: 1 })
                                ]))
                            ),
                            query('.collection-post .right', 
                                animate("2s 1.8s cubic-bezier(0.645, 0.045, 0.355, 1)", keyframes([
                                    style({ opacity: 0, offset: 0.2}),
                                    style({ opacity: 1, offset: 0.4}),
                                    style({ transform: 'translateX(0)', offset: 1}),
                                ])),{optional:true}  
                            ),
                        ]),
                        query('.collection-post .right .content .width', stagger(400,[
                            animate("1.2s ease-out", 
                                style({
                                    transform: 'translateY(0px)',
                                    opacity: 1
                                })
                            )])
                        ),
                        query('.collection-post .right .list-block-carpet', 
                            animate("3s cubic-bezier(0.23, 1, 0.32, 1)", 
                                style({
                                    transform: 'translateY(0)'
                                })
                            )
                        ),
                        query('.collection-post .slider-images-bg', animate('0.4s linear', 
                            style({
                                opacity: 1
                            })),{optional:true} 
                        ),
                    ]),
                    transition(':leave', [
                        style({
                            opacity: 1,
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 1
                        }),
                        animate('1s ease-out', style({
                            opacity: 0
                        }))
                    ])
                ])
            },
            {
            //1400px
                'view' : mediaQuerys["1400px"].matches,
                'state' : trigger('collectionPost', [
                    transition(':enter', [
                        style({
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 2
                        }),            
                        query('.collection-post .right', 
                            style({
                                opacity: 0,
                                width: '65%',
                                transform: 'translateX(180%)',
                                'will-change': 'auto'
                            })
                        ),
                        query('#masker-collection-post', 
                            style({
                                transform: 'scale(0)',
                                'will-change': 'auto'
                            })
                        ), 
                        query('.collection-post .right .content .width', 
                            style({
                                opacity: 0,
                                transform: 'translateY(200px)',
                                'will-change': 'auto'
                            })
                        ),
                        query('.collection-post .right .list-block-carpet', 
                            style({
                                transform: 'translateY(105%)',
                                'will-change': 'transform'
                            })
                        ),
                        query('.collection-post .slider-images-bg',  
                            style({
                                opacity: 0,
                                'will-change': 'opacity'
                            }),{optional:true}
                        ), 
                        //animate
                        group([   
                            query('#masker-collection-post', 
                                animate("1s ease-out", keyframes([
                                    style({ opacity: 0, offset: 0 }),
                                    style({ transform: 'scale(0.01)', opacity: 1, offset: 0.2 }),
                                    style({ transform: 'scale(1)', offset: 1 })
                                ]))
                            ),  
                            query('.collection-post .right', 
                                animate("2s 1.8s cubic-bezier(0.645, 0.045, 0.355, 1)", keyframes([
                                    style({ opacity: 0, offset: 0.2}),
                                    style({ opacity: 1, offset: 0.4}),
                                    style({ transform: 'translateX(0)', offset: 1}),
                                ])),{optional:true}  
                            ),
                        ]),
                        query('.collection-post .right .content .width', stagger(400,[
                            animate("1.2s ease-out", 
                                style({
                                    transform: 'translateY(0px)',
                                    opacity: 1
                                })
                            )])
                        ),
                        query('.collection-post .right .list-block-carpet', 
                            animate("3s cubic-bezier(0.23, 1, 0.32, 1)", 
                                style({
                                    transform: 'translateY(0)'
                                })
                            )
                        ),
                        query('.collection-post .slider-images-bg', animate('0.4s linear', 
                            style({
                                opacity: 1
                            })),{optional:true}
                        )         
                    ]),
                    transition(':leave', [
                        style({
                            opacity: 1,
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 1
                        }),
                        animate('1s ease-out', style({
                            opacity: 0
                        }))
                    ])
                ])
            },
            {
                //500px
                'view' : mediaQuerys["500px"].matches,
                'state' : trigger('collectionPost', [
                    transition(':enter', [
                        style({
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 2
                        }),
                        query('#masker-collection-post', 
                            style({
                                opacity: 0,
                                transform: 'scale(0)',
                                'will-change': 'transform, opacity'
                            }),{optional:true}
                        ),            
                        query('.collection-post .right', 
                            style({
                                opacity: 0,
                                transform: 'translateY(50%)',
                                'will-change': 'auto'
                            }),{optional:true}
                        ),
                        query('.collection-post .right .list-block-carpet', 
                            style({
                                transform: 'translateX(105%)',
                                'will-change': 'transform'
                            }),{optional:true}
                        ),
                        query('.collection-post .slider-images-bg', 
                            style({
                                opacity: 0,
                                'will-change': 'opacity'
                            }),{optional:true}
                        ), 
                        //animate
                        group([
                            query('#masker-collection-post', 
                                animate("1s ease-out", keyframes([
                                    style({ opacity: 0, offset: 0 }),
                                    style({ transform: 'scale(0.01)', opacity: 1, offset: 0.2 }),
                                    style({ transform: 'scale(1)', opacity: 1, offset: 1 })
                                ])),{optional:true}
                            ),     
                            query('.collection-post .right', 
                                animate("1s ease-in", style({
                                    opacity: 1,
                                    transform: 'translateY(0)'
                                })),{optional:true}  
                            ),
                        ]),
                        query('.collection-post .right .list-block-carpet', 
                            animate("0.4s cubic-bezier(0.23, 1, 0.32, 1)", 
                                style({
                                    transform: 'translateX(0)'
                                })
                            ),{optional:true}
                        ),
                        query('.collection-post .slider-images-bg', animate('1000000s linear', 
                            style({
                                opacity: 1
                            })),{optional:true}
                        )    
                    ]),
                    transition(':leave', [
                        style({
                            opacity: 1,
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '100%',
                            'z-index': 1
                        }),
                        animate('1s ease-out', style({
                            opacity: 0
                        }))
                    ])
                ])
            },
        ],
            //default
            trigger('collectionPost', [
                transition(':enter', [
                    style({
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        height: '100%',
                        width: '100%',
                        'z-index': 2
                    }),        
                    query('#masker-collection-post', 
                        style({
                            transform: 'scale(0)',
                            'will-change': 'auto'
                        })
                    ),    
                    query('.collection-post .right', 
                        style({
                            opacity: 0,
                            width: '50%',
                            transform: 'translateX(100%)',
                            'will-change': 'auto'
                        })
                    ),
                    query('.collection-post .right .content .width', 
                        style({
                            opacity: 0,
                            transform: 'translateY(200px)',
                            'will-change': 'auto'
                        })
                    ),
                    query('.collection-post .right .list-block-carpet', 
                        style({
                            transform: 'translateY(105%)',
                            'will-change': 'transform'
                        })
                    ),
                    query('.collection-post .slider-images-bg', 
                        style({
                            opacity: 0,
                            'will-change': 'opacity'
                        }),{optional:true}
                    ),

                    //animate
                    group([  
                        query('#masker-collection-post', 
                            animate("1s ease-out", keyframes([
                                style({ opacity: 0, offset: 0 }),
                                style({ transform: 'scale(0.01)', opacity: 1, offset: 0.2 }),
                                style({ transform: 'scale(1)', offset: 1 })
                            ]))
                        ),
                        query('.collection-post .right', 
                            animate("2s 1.8s cubic-bezier(0.645, 0.045, 0.355, 1)", keyframes([
                                style({ opacity: 0, offset: 0.2}),
                                style({ opacity: 1, offset: 0.4}),
                                style({ transform: 'translateX(0)', offset: 1}),
                            ])),{optional:true}  
                        ),
                    ]),
                    query('.collection-post .right .content .width', stagger(400,[
                        animate("1.2s ease-out", 
                            style({
                                transform: 'translateY(0px)',
                                opacity: 1
                            })
                        )])
                    ),
                    query('.collection-post .right .list-block-carpet', 
                        animate("3s cubic-bezier(0.23, 1, 0.32, 1)", 
                            style({
                                transform: 'translateY(0)'
                            })
                        )
                    ),
                    query('.collection-post .slider-images-bg', animate('0.4s linear', 
                        style({
                            opacity: 1
                        })),{optional:true}
                    ),
                ]),
                transition(':leave', [
                    style({
                        opacity: 1,
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        height: '100%',
                        width: '100%',
                        'z-index': 1
                    }),
                    animate('1s ease-out', style({
                        opacity: 0
                    }))
                ])
            ])
        );


// WEBPACK FOOTER //
// ./src/app/animation/animate.ts